<!-- SUCCESS -->
<div class="flexWrapper" *ngIf="status === 'success'">
  <img class="icon" src="../../../assets/images/email-verification.png" />
  <div class="title">Email <span class="lastWord">Verified</span></div>
  <div class="content">
    Your email address was successfully verified.
  </div>
</div>

<div class="flexWrapper expired" *ngIf="status === 'expired'">
  <div class="title"> <span class="expiredLink">Link Expired</span></div>
  <div class="expired-content">
    This confirmation link has already been used or has expired.
  </div>
</div>
